module.exports = __webpack_public_path__ + "static/media/healthcare_doc_p1_1.398d78af.png";